import { render, staticRenderFns } from "./PacotesDoPaciente.vue?vue&type=template&id=7144b81d&"
import script from "./PacotesDoPaciente.vue?vue&type=script&lang=js&"
export * from "./PacotesDoPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports